var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6719 10.8867V20.0156C19.6719 20.6124 19.4348 21.1847 19.0129 21.6066C18.5909 22.0286 18.0186 22.2656 17.4219 22.2656H6.92188C6.32514 22.2656 5.75284 22.0286 5.33088 21.6066C4.90893 21.1847 4.67188 20.6124 4.67188 20.0156V5.01562C4.67188 4.41889 4.90893 3.84659 5.33088 3.42463C5.75284 3.00268 6.32514 2.76563 6.92188 2.76562H11.5508C11.9485 2.76569 12.3299 2.92367 12.6111 3.20484L19.2327 9.82641C19.5138 10.1076 19.6718 10.489 19.6719 10.8867Z",
    stroke: "#9C4900",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1719 3.14062V8.76562C12.1719 9.16345 12.3299 9.54498 12.6112 9.82628C12.8925 10.1076 13.2741 10.2656 13.6719 10.2656H19.2969",
    stroke: "#9C4900",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.ac358d09a8e6bf8fa9e27d0dac83ed55.svg";
export { ForwardRef as ReactComponent };